import { __rest } from "tslib";
import * as React from 'react';
import { Divider as AntdDivider } from 'antd';
import './divider.scss';
const Divider = props => {
    const { color = '#E1E3E8', className, margin = 15, children } = props, restProps = __rest(props, ["color", "className", "margin", "children"]);
    const classes = React.useMemo(() => {
        let res = 'lx-divider';
        if (className) {
            res += className;
        }
        return res;
    }, [className]);
    return (React.createElement(AntdDivider, Object.assign({ className: classes }, restProps, { style: { borderTopColor: color, margin: `${margin}px 0` } }), children));
};
export default Divider;
